import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/data/content";

const WhatsAppButton = () => (
  <a
    href={whatsappLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Contattaci su WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold pl-4 pr-5 py-3 shadow-crisp-lg rounded-full transition-all duration-300 hover:scale-105 group"
  >
    <MessageCircle className="w-6 h-6" />
    <span className="hidden sm:inline text-sm max-w-0 group-hover:max-w-[140px] overflow-hidden whitespace-nowrap transition-all duration-300">
      Scrivici su WhatsApp
    </span>
  </a>
);

export default WhatsAppButton;
